import { TRIAL_UPGRADE_URL } from "../utils/trial";

// Inline banner shown where a trial user's list stops being readable — same look as the one
// in SignalTable, usable in lists, cards and grids (pass "col-span-full" for a grid).
export default function TrialLockBanner({ hiddenCount, className = "" }: { hiddenCount: number; className?: string }) {
    if (hiddenCount <= 0) return null;
    return (
        <div className={`flex items-center justify-between gap-3 flex-wrap px-6 py-3 bg-surface-sunken border-y border-border ${className}`}>
            <div className="flex items-center gap-2 text-sm text-ink-muted">
                <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                </svg>
                <span>
                    <strong>{hiddenCount} résultat{hiddenCount > 1 ? "s" : ""} supplémentaire{hiddenCount > 1 ? "s" : ""}</strong> masqué{hiddenCount > 1 ? "s" : ""} - disponible{hiddenCount > 1 ? "s" : ""} avec l'offre complète
                </span>
            </div>
            <a
                href={TRIAL_UPGRADE_URL}
                target="_blank"
                rel="noreferrer"
                className="text-xs font-medium bg-ink text-ink-inverse px-3 py-1.5 rounded-full hover:bg-ink/90 transition-colors duration-150 flex-shrink-0"
            >
                Passer à Pro →
            </a>
        </div>
    );
}
